"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: h, size: e = 24 } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = s(), o = h !== null && h !== void 0 ? h : l ? c.colors.inverse : c.colors.neutralHigh, { skinName: r } = n();
    return r.match(/^blau/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ i("path", {
            fill: o,
            d: "M15 2H8.571A3.58 3.58 0 0 0 5 5.571V18.43A3.58 3.58 0 0 0 8.571 22H15a3.58 3.58 0 0 0 3.571-3.571V5.57A3.58 3.58 0 0 0 15 2M6.429 17.357V6.643h10.714v10.714zM8.57 3.43H15c1.071 0 1.929.785 2.107 1.785H6.464c.179-1 1.036-1.785 2.107-1.785M15 20.57H8.571c-1.071 0-1.928-.785-2.107-1.785h10.643c-.178 1-1.036 1.785-2.107 1.785"
        })
    })) : r.match(/^o2-new/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ i("path", {
            fill: o,
            d: "M8.784 2h6.432a3.575 3.575 0 0 1 3.568 3.572v12.856A3.58 3.58 0 0 1 15.212 22H8.784a3.58 3.58 0 0 1-3.572-3.572V5.572A3.58 3.58 0 0 1 8.784 2m-2.14 4.644V17.36H17.36V6.644zm2.14-3.216c-1.06 0-1.94.776-2.112 1.784h10.652a2.145 2.145 0 0 0-2.112-1.784zm0 17.144h6.432c1.06 0 1.94-.776 2.108-1.784H6.672a2.145 2.145 0 0 0 2.112 1.784"
        })
    })) : r.match(/^o2/i) ? /* @__PURE__ */ i("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ i("path", {
            fill: o,
            d: "M8.784 2h6.432a3.575 3.575 0 0 1 3.568 3.572v12.856A3.58 3.58 0 0 1 15.212 22H8.784a3.58 3.58 0 0 1-3.572-3.572V5.572A3.58 3.58 0 0 1 8.784 2m-2.14 4.644V17.36H17.36V6.644zm2.14-3.216c-1.06 0-1.94.776-2.112 1.784h10.652a2.145 2.145 0 0 0-2.112-1.784zm0 17.144h6.432c1.06 0 1.94-.776 2.108-1.784H6.672a2.145 2.145 0 0 0 2.112 1.784"
        })
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ i("path", {
                fill: o,
                d: "M11.39 19.862q.18.05.388.05c.353 0 .653-.112.85-.315q.297-.305.298-.835c0-.72-.425-1.15-1.145-1.15s-1.148.43-1.148 1.15q0 .526.298.835.184.188.46.265"
            }),
            /* @__PURE__ */ i("path", {
                fill: o,
                d: "M8.396 22.32c-1.141 0-1.974-.275-2.543-.838-.575-.57-.853-1.408-.853-2.558V5.396c0-1.121.278-1.945.85-2.526C6.428 2.286 7.26 2 8.396 2h6.764c1.145 0 1.977.277 2.55.853.572.575.846 1.404.846 2.543v13.528c0 1.15-.28 1.988-.852 2.558-.573.563-1.402.838-2.544.838zm0-19.164c-1.59 0-2.24.65-2.24 2.24v13.528c0 1.633.607 2.24 2.24 2.24h6.764c1.633 0 2.24-.607 2.24-2.24V5.396c0-.818-.168-1.384-.509-1.728s-.91-.512-1.731-.512z"
            })
        ]
    }));
}, H = m;
export { H as default };
